import { useIsLandscapeMobile } from '@/lib/useDeviceType'
import React from 'react'
import { Image } from 'react-native'
import { XStack, YStack } from 'tamagui'
import { LessonStructuredTitleBlock } from '../lesson/LessonStructuredTitleBlock'
import { Lesson, UserLesson } from '../../types'
import { getLessonStructuredTitleMeta } from '../../utils/lessonStructuredTitle'
import { lessonThumbnailProgressPercent } from '../../utils/lessonProgressPercent'
import { useResponsiveImageUrl } from '../../utils/imageUtils'

type Props = {
  item: Lesson
  userLesson?: UserLesson
  onPress?: () => void
}

export const SuggestedLessonCard: React.FC<Props> = ({ item, userLesson, onPress }) => {
  const responsiveImageUrl = useResponsiveImageUrl(item.thumbnail || '', 'card')
  const { displayTitle, metaLine } = getLessonStructuredTitleMeta(item)

  const progress = userLesson
    ? lessonThumbnailProgressPercent({
        userProgress: userLesson.progress,
        videoCount: item.video_count,
        completedVideoCount: userLesson.completed_video_count,
        leftOffAtSeconds: userLesson.left_off_at_seconds,
        durationSeconds: item.duration,
      })
    : (item.progressPercentage ?? 0)
  const isLandscapeMobile = useIsLandscapeMobile()

  return (
    <XStack
      w="100%"
      br={10}
      backgroundColor="white"
      my="$3"
      shadowColor="rgba(0, 0, 0, 0.8)"
      shadowOffset={{ width: 0, height: 0 }}
      shadowOpacity={0.2}
      shadowRadius={3}
      alignItems="center"
      hoverStyle={{ scale: 1.02 }}
      animation="bouncy"
      onPress={onPress}
    >
      <YStack
        w={isLandscapeMobile ? "20%" : "40%"}
        aspectRatio={16 / 9}
        overflow="hidden"
        borderBottomLeftRadius={10}
        borderBottomRightRadius={10}
        position="relative"
      >
        <Image
          source={{ uri: responsiveImageUrl }}
          style={{
            width: '100%',
            height: '100%',
            resizeMode: 'cover',
            borderRadius: 10,
          }}
        />

        <YStack
          position="absolute"
          bottom={0}
          left={0}
          height={3}
          width="100%"
          backgroundColor="#C9C5C3"
        >
          <YStack height="100%" width={`${progress}%`} backgroundColor="#F2663A" />
        </YStack>
      </YStack>

      <YStack w="60%" jc="center" px="$4" py="$2">
        <LessonStructuredTitleBlock
          displayTitle={displayTitle}
          metaLine={metaLine}
          titleColor="$color12"
          variant="suggested"
        />
      </YStack>
    </XStack>
  )
}

export default SuggestedLessonCard